import { render, staticRenderFns } from "./analysis-page.vue?vue&type=template&id=24ddbbd4&scoped=true&"
import script from "./analysis-page.vue?vue&type=script&lang=js&"
export * from "./analysis-page.vue?vue&type=script&lang=js&"
import style0 from "./analysis-page.vue?vue&type=style&index=0&id=24ddbbd4&prod&scoped=true&lang=less&"
import style1 from "./analysis-page.vue?vue&type=style&index=1&id=24ddbbd4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ddbbd4",
  null
  
)

export default component.exports